import { putMultipleFundingSourceForClientByClientIdRequest } from '../model';
import { createGenericContext } from '../util/contextCreator';
import { InsuranceFormFields } from './InsuranceFormFields';
import { InsuranceFormErrors } from '../util/usePolicyForm';

type PolicyInputFormProps = {
  policyState: PolicyFundingSource;
  formErrors: InsuranceFormErrors;
  handleChangePolicyField: (
    policyKey: PolicyFieldKey,
    parser?: (value: PolicyFieldValue) => PolicyFieldValue,
  ) => (value: PolicyFieldValue) => void;
  maxBenefitsInterval: MaxBenefitsIntervalType;
  handleMaxBenefitsIntervalChange: (interval: MaxBenefitsIntervalType) => void;
};

export const [PolicyInputFormContextProvider, usePolicyInputFormContext] =
  createGenericContext<PolicyInputFormProps>();

export function PolicyInputForm({
  handleChangePolicyField,
  policyState,
  formErrors,
  maxBenefitsInterval,
  handleMaxBenefitsIntervalChange,
}: PolicyInputFormProps) {
  return (
    <PolicyInputFormContextProvider
      value={{
        formErrors,
        policyState,
        handleChangePolicyField,
        maxBenefitsInterval,
        handleMaxBenefitsIntervalChange,
      }}
    >
      <InsuranceFormFields />
    </PolicyInputFormContextProvider>
  );
}

export function dispatchPolicyUpdate(
  dispatch: any,
  clientId: string,
  fundingSourceId: string,
  multipleFundingSources: MultipleFundingSources,
  policyKey: PolicyFieldKey,
  value: PolicyFieldValue,
) {
  const ltcPolicy = multipleFundingSources.ltcPolicy[fundingSourceId];
  const selfFunding = multipleFundingSources.selfFunding[fundingSourceId];

  const source =
    (ltcPolicy && {
      type: 'ltcPolicy' as const,
      data: {
        ...ltcPolicy,
        policyAddedAt: ltcPolicy?.policyAddedAt || Date.now(),
      },
    }) ||
    (selfFunding && { type: 'selfFunding' as const, data: selfFunding });

  if (!source) {
    console.warn('No funding source found for id: ', fundingSourceId);
    return;
  }

  const updatedSource = {
    ...source.data,
    [policyKey]: value,
  } as (typeof source)['data'];

  dispatch(
    putMultipleFundingSourceForClientByClientIdRequest({
      clientId,
      fundingSourceType: source.type,
      fundingSourceData: updatedSource,
      fundingSourceId,
    }),
  );
}
